module.exports = __webpack_public_path__ + "img/zfb.91734df.svg";